import React, { useState, createContext, useCallback, useEffect } from 'react'
import { cloneDeep, forEach } from 'lodash'
import { useCookie } from '@use-hook/use-cookie'
import qs from 'query-string'
import Axios from 'axios'
import { Base64 } from 'js-base64'
import { useLocation } from 'react-router'

export const UserContext = createContext()

export const UserProvider = (props) => {
  const [user, setUser] = useState({})
  const [isSocial, setIsSocial] = useState(false)
  const [socialType, setSocialType] = useState(undefined)
  const [authValue, setAuthValue] = useCookie('8egma2jfs9mu')
  const [fetchingUser, setFetchingUser] = useState(true)
  const [loggedUser, setLoggedUser] = useState({})
  const { search } = useLocation()
  const { query: { api_key, from } } = qs.parseUrl(search)

  useEffect(() => {
    if (api_key) {
      const checkApikey = async () => {
        try {
          await Axios.post(`${process.env.REACT_APP_API_PATH}/user`, {}, {
            headers: {
              Authorization: `Bearer ${Base64.decode(api_key)}`
            }
          })
          setAuthValue(api_key)
          if (from) window.location.href = decodeURIComponent(from)
        } catch (e) {
          console.error(e)
        }
      }

      checkApikey()
    } 
  }, [api_key, from, setAuthValue])

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data: { data: loggedUser = {} } = {} } = await Axios.post(`${process.env.REACT_APP_API_PATH}/user`, {}, {
          headers: {
            Authorization: `Bearer ${Base64.decode(authValue)}`
          }
        })
        setLoggedUser(loggedUser)
        setFetchingUser(false)
      } catch (e) {
        setFetchingUser(false)
      }
    }
    checkAuth()
  }, [authValue])

  const setFields = useCallback((fields) => {
    if (fields.loginType) {
      setIsSocial(true)
      setSocialType(fields.loginType)
    }
    const clonedUser = cloneDeep(user)
    forEach(fields, (field, index) => {
      clonedUser[index] = field
    })
    setUser(clonedUser)
  }, [user])
  return (
    <UserContext.Provider
      value={{
        user,
        isSocial,
        socialType,
        setFields,
        setUser,
        fetchingUser,
        loggedUser
      }}
    >
      {props.children}
    </UserContext.Provider>
  )
}